export const redirect = async (redirectPath: string): Promise<void> => {
  // Gatsby build doesn't have a window, need to check here
  if (typeof window !== 'undefined') {
    window.location.href = redirectPath
  }
}
